(() => {
  const CSS = `
    form{display:flex!important;flex-direction:row!important;align-items:center!important;gap:8px!important;background:#f3f3f3;border:1px solid #e9e9e9;border-radius:9999px;padding:8px 8px 8px 16px;margin:0;box-sizing:border-box;width:100%}
    form>*{min-width:0!important} form>:not(button){flex:1 1 auto!important}
    input[type="email"],input[type="text"],input[autocomplete="email"],input[inputmode="email"]{
      width:100%!important;height:44px!important;border:0!important;background:transparent!important;outline:0!important;box-shadow:none!important;
      font-size:16px!important;line-height:1!important;padding:0 10px!important;margin:0!important;appearance:none!important;opacity:1!important}
    input::placeholder{color:rgba(0,0,0,.55)!important;opacity:1!important}
    label{display:none!important}
    button[type="submit"]{flex:0 0 auto!important;width:56px!important;height:56px!important;min-width:0!important;margin:0!important;padding:0!important;border:0!important;border-radius:50%!important;background:#000!important;color:#fff!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;font-size:0!important;line-height:0!important;cursor:pointer}
    @media (max-width:480px){input[type="email"],input[type="text"],input[autocomplete="email"],input[inputmode="email"]{height:40px!important;font-size:16px!important}button[type="submit"]{width:48px!important;height:48px!important}}
  `;

  const LABEL_TEXT = 'E-mail';

  function inject(host){
    const sr = host.shadowRoot;
    if (!sr) return false;

    // Add our styles once
    if (!sr.querySelector('style[data-pill]')){
      const style = document.createElement('style');
      style.setAttribute('data-pill','');
      style.textContent = CSS;
      sr.prepend(style);
    }

    // Force placeholder/label text to "E-mail"
    const input = sr.querySelector('input[type="email"], input[autocomplete="email"], input[type="text"]');
    if (input){
      input.placeholder = LABEL_TEXT;
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', LABEL_TEXT);
      const lbl = sr.querySelector('label[for="'+(input.id||'')+'"], label');
      if (lbl) lbl.textContent = LABEL_TEXT; // hidden, but keeps semantics
    }

    // Ensure arrow icon
    const btn = sr.querySelector('button[type="submit"]');
    if (btn && !btn.querySelector('svg')){
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 5l8 7-8 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    host.__pillApplied = true;
    return true;
  }

  function ensure(host){
    if (inject(host)) return;
    let tries = 60; // retry while the app mounts
    (function tick(){
      if (inject(host)) return;
      if (--tries <= 0) return;
      setTimeout(tick, 200);
    })();
    const mo = new MutationObserver(() => { inject(host); if (host.__pillApplied) mo.disconnect(); });
    mo.observe(host, { childList:true, subtree:true });
  }

  function scan(){ document.querySelectorAll('.newsletter-form form-embed').forEach(ensure); }

  function init(){
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList:true, subtree:true });
    window.customElements?.whenDefined?.('form-embed').then(scan);
    window.addEventListener('shopify:section:load', scan);
    window.addEventListener('load', scan);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
